import userStore from "./userStore";
import { useShallow } from "zustand/react/shallow";

const useUserStore = () => {
  const {
    isAuthenticated,
    isSuperUser,
    token,
    refreshToken,
    permissions,
    userId,
    userName,
    login,
    refresh,
    handoff,
    checkToken,
    logout,
  } = userStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
      isSuperUser: state.isSuperUser,
      token: state.token,
      refreshToken: state.refreshToken,
      permissions: state.permissions,
      userId: state.userId,
      userName: state.userName,
      login: state.login,
      refresh: state.refresh,
      handoff: state.handoff,
      checkToken: state.checkToken,
      logout: state.logout,
    }))
  );

  return {
    isAuthenticated,
    isSuperUser,
    token,
    refreshToken,
    permissions,
    userId,
    userName,
    login,
    refresh,
    handoff,
    checkToken,
    logout,
  };
};

export default useUserStore;
